function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h20v20H0z" /><path fill="currentColor" d="M4.833 16.333c0 .917.75 1.667 1.667 1.667h6.667c.916 0 1.666-.75 1.666-1.667V8c0-.917-.75-1.667-1.666-1.667H6.5c-.917 0-1.667.75-1.667 1.667zm10-12.5H12.75l-.592-.591A.84.84 0 0 0 11.575 3H8.092a.842.842 0 0 0-.584.242l-.591.591H4.833A.836.836 0 0 0 4 4.667c0 .458.375.833.833.833h10a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.834z" /></g></svg>;
});